import { render, staticRenderFns } from "./FlexyTransaction.vue?vue&type=template&id=704a27fa"
import script from "./FlexyTransaction.vue?vue&type=script&lang=js"
export * from "./FlexyTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports